import { create } from 'zustand'

const useModalStore =create((set) => ({
    isOpen: false,
    setModalState: (state) => set({isOpen : state})
  }));

export default useModalStore